import { combineReducers } from 'redux';
import reducers from './reducers';
import dishSearch from './dishSearch';
import searchParams from './searchParams';
import dishDelete from './dishDelete';
import dishEdit from './dishEdit';
import menu from './menu';
import menuDelete from './menuDelete';
import calculateCbgu from './calculateCbgu';
import login from './login';
import loader from './loader';
import setParams from './setParams';
import getTags from './getTags';
import getAllMealTypes from './getAllMealTypes';
import template from './template';
import templateDelete from './templateDelete';
import dishTemplate from './dishTemplate';
import tagDelete from './tagDelete';
import tagEdit from './tagEdit';
import complex from './complex';
import templateGenerator from './templateGenerator';
import folders from './folders';
import trainingVideos from './trainingVideos';
import basket from './basket';
import newYouslim from './newYouslim';

export default combineReducers({
  reducers,
  dishSearch,
  searchParams,
  dishDelete,
  dishEdit,
  menu,
  menuDelete,
  calculateCbgu,
  login,
  loader,
  setParams,
  getTags,
  getAllMealTypes,
  template,
  templateDelete,
  dishTemplate,
  tagDelete,
  tagEdit,
  complex,
  templateGenerator,
  folders,
  trainingVideos,
  basket,
  newYouslim,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js